var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split-loader"},[_c('loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"size":_vm.loaderSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }